import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CalculadoraTevGuard } from './pages/calculadoras/calculadora-tev/calculadora-tev.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'cid',
    loadChildren: () => import('./pages/cid/cid.module').then(m => m.CidPageModule)
  },
  {
    path: 'linksuteis',
    loadChildren: () => import('./pages/linksuteis/linksuteis.module').then(m => m.LinksuteisPageModule)
  },
  {
    path: 'tuss',
    loadChildren: () => import('./pages/tuss/tuss.module').then(m => m.TussPageModule)
  },
  {
    path: 'calculadoras/calculadora-imc',
    loadChildren: () => import('./pages/calculadoras/calculadora-imc/calculadora-imc.module').then(m => m.CalculadoraImcPageModule)
  },
  {
    path: 'calculadoras/calculadora-bishop',
    loadChildren: () => import('./pages/calculadoras/calculadora-bishop/calculadora-bishop.module').then(m => m.CalculadoraBishopPageModule)
  },
  {
    path: 'calculadoras/calculadora-tev',
    canActivate: [CalculadoraTevGuard],
    loadChildren: () => import('./pages/calculadoras/calculadora-tev/calculadora-tev.module').then(m => m.CalculadoraTevPageModule)
  },
  {
    path: 'calculadoras',
    loadChildren: () => import('./pages/calculadoras/calculadoras.module').then(m => m.CalculadorasPageModule)
  },
  {
    path: 'calculadora',
    loadChildren: () => import('./pages/calculadora/calculadora.module').then(m => m.CalculadoraPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'revistas',
    loadChildren: () => import('./pages/revistas/revistas.module').then(m => m.RevistasPageModule)
  },
  {
    path: 'orientacoes',
    loadChildren: () => import('./pages/orientacoes/orientacoes.module').then(m => m.OrientacoesPageModule)
  },
  {
    path: 'protocolo',
    loadChildren: () => import('./pages/protocolo/protocolo.module').then(m => m.ProtocoloPageModule)
  },
  {
    path: 'position',
    loadChildren: () => import('./pages/position/position.module').then(m => m.PositionPageModule)
  },
  {
    path: 'termos',
    loadChildren: () => import('./pages/termos/termos.module').then(m => m.TermosPageModule)
  },
  {
    path: 'femina',
    loadChildren: () => import('./pages/femina/femina.module').then(m => m.FeminaPageModule)
  },
  {
    path: 'revistaela',
    redirectTo: '/revistas',
    pathMatch: 'full'
  },
  {
    path: 'instrucoes',
    loadChildren: () => import('./pages/instrucoes/instrucoes.module').then(m => m.InstrucoesPageModule)
  },
  {
    path: 'rbgo',
    loadChildren: () => import('./pages/rbgo/rbgo.module').then(m => m.RbgoPageModule)
  },
  {
    path: 'noticias',
    loadChildren: () => import('./pages/noticias/noticias.module').then(m => m.NoticiasPageModule)
  },
  {
    path: 'single-rbgo',
    loadChildren: () => import('./pages/single-rbgo/single-rbgo.module').then(m => m.SingleRbgoPageModule)
  },
  {
    path: 'single-noticia',
    loadChildren: () => import('./pages/single-noticia/single-noticia.module').then(m => m.SingleNoticiaPageModule)
  },
  {
    path: 'concursos',
    loadChildren: () => import('./pages/concursos/concursos.module').then(m => m.ConcursosPageModule)
  },
  {
    path: 'duvidas',
    loadChildren: () => import('./pages/duvidas/duvidas.module').then(m => m.DuvidasPageModule)
  },
  {
    path: 'eventos',
    loadChildren: () => import('./pages/eventos/eventos.module').then(m => m.EventosPageModule)
  },
  {
    path: 'single-eventos',
    loadChildren: () => import('./pages/single-eventos/single-eventos.module').then(m => m.SingleEventosPageModule)
  },
  {
    path: 'cid-interno',
    loadChildren: () => import('./pages/cid-interno/cid-interno.module').then(m => m.CidInternoPageModule)
  },
  {
    path: 'tuss-interno',
    loadChildren: () => import('./pages/tuss-interno/tuss-interno.module').then(m => m.TussInternoPageModule)
  },
  {
    path: 'calculadora-interno',
    loadChildren: () => import('./pages/calculadora-interno/calculadora-interno.module').then(m => m.CalculadoraInternoPageModule)
  },
  {
    path: 'busca-geral',
    loadChildren: () => import('./pages/busca-geral/busca-geral.module').then(m => m.BuscaGeralPageModule)
  },
  {
    path: 'guia',
    loadChildren: () => import('./pages/guia/guia.module').then(m => m.GuiaPageModule)
  },
  {
    path: 'codigos-procedimentos',
    loadChildren: () => import('./pages/codigos-procedimentos/codigos-procedimentos.module').then(m => m.CodigosProcedimentosPageModule)
  },
  {
    path: 'sus',
    loadChildren: () => import('./pages/sus/sus.module').then(m => m.SusPageModule)
  },
  {
    path: 'esqueci-senha',
    loadChildren: () => import('./pages/esqueci-senha/esqueci-senha.module').then(m => m.EsqueciSenhaPageModule)
  },
  {
    path: 'confirmar-senha',
    loadChildren: () => import('./pages/confirmar-senha/confirmar-senha.module').then(m => m.ConfirmarSenhaPageModule)
  },
  {
    path: 'sucesso-senha',
    loadChildren: () => import('./pages/sucesso-senha/sucesso-senha.module').then(m => m.SucessoSenhaPageModule)
  },
  {
    path: 'cadastro-logbook',
    loadChildren: () => import('./pages/cadastro-logbook/cadastro-logbook.module').then(m => m.CadastroLogbookPageModule)
  },
  {
    path: 'cadastro-logbook-associado',
    loadChildren: () => import('./pages/cadastro-logbook-associado/cadastro-logbook-associado.module').then(m => m.CadastroLogbookAssociadoPageModule)
  },
  {
    path: 'home-n-associado-s-lg',
    loadChildren: () => import('./pages/home-n-associado-s-lg/home-n-associado-s-lg.module').then(m => m.HomeNAssociadoSLgPageModule)
  },
  {
    path: 'home-associado-residente',
    loadChildren: () => import('./pages/home-associado-residente/home-associado-residente.module').then(m => m.HomeAssociadoResidentePageModule)
  },
  {
    path: 'home-associado-s-lg',
    loadChildren: () => import('./pages/home-associado-s-lg/home-associado-s-lg.module').then(m => m.HomeAssociadoSLgPageModule)
  },
  {
    path: 'logbook-procedimentos',
    loadChildren: () => import('./pages/logbook-procedimentos/logbook-procedimentos.module').then(m => m.LogbookProcedimentosPageModule)
  },
  {
    path: 'logbook-procedimentos-vinculados',
    loadChildren: () => import('./pages/logbook-procedimentos-vinculados/logbook-procedimentos-vinculados.module').then(m => m.LogbookProcedimentosVinculadosPageModule)
  },
  {
    path: 'logbook-preceptores-vinculados',
    loadChildren: () => import('./pages/logbook-preceptores-vinculados/logbook-preceptores-vinculados.module').then(m => m.LogbookPreceptoresVinculadosPageModule)
  },
  {
    path: 'logbook-residentes-vinculados',
    loadChildren: () => import('./pages/logbook-residentes-vinculados/logbook-residentes-vinculados.module').then(m => m.LogbookResidentesVinculadosPageModule)
  },
  {
    path: 'logbook-preceptores-e-procedimentos-vinculados',
    loadChildren: () => import('./pages/logbook-preceptores-e-procedimentos-vinculados/logbook-preceptores-e-procedimentos-vinculados.module').then(m => m.LogbookPreceptoresEProcedimentosVinculadosPageModule)
  },
  {
    path: 'logbook',
    loadChildren: () => import('./pages/logbook/logbook.module').then(m => m.LogbookPageModule)
  },
  {
    path: 'logbook-gerar-relatorio-residente',
    loadChildren: () => import('./pages/logbook-gerar-relatorio-residente/logbook-gerar-relatorio-residente.module').then( m => m.LogbookGerarRelatorioResidentePageModule)
  },
  {
    path: 'logbook-gerar-relatorio-preceptor',
    loadChildren: () => import('./pages/logbook-gerar-relatorio-preceptor/logbook-gerar-relatorio-preceptor.module').then( m => m.LogbookGerarRelatorioPreceptorPageModule)
  },
  {
    path: 'logbook-gerar-relatorio-supervisor',
    loadChildren: () => import('./pages/logbook-gerar-relatorio-supervisor/logbook-gerar-relatorio-supervisor.module').then( m => m.LogbookGerarRelatorioSupervisorPageModule)
  },
  {
    path: 'notificacoes',
    loadChildren: () => import('./pages/notificacoes/notificacoes.module').then( m => m.NotificacoesPageModule)
  },
  {
    path: 'reload',
    loadChildren: () => import('./reload/reload.module').then( m => m.ReloadPageModule)
  },
  {
    path: 'fluxogramas',
    loadChildren: () => import('./pages/fluxogramas/fluxogramas.module').then( m => m.FluxogramasPageModule)
  },
  {
    path: 'comissao-obstetricas',
    loadChildren: () => import('./pages/comissao-obstetricas/comissao-obstetricas.module').then( m => m.ComissaoObstetricasPageModule)
  },
  {
    path: 'comissao-gestacao',
    loadChildren: () => import('./pages/comissao-gestacao/comissao-gestacao.module').then( m => m.ComissaoGestacaoPageModule)
  },
  {
    path: 'flowcharts',
    loadChildren: () => import('./pages/flowcharts/flowcharts.module').then( m => m.FlowchartsPageModule)
  },






];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }


